import PropTypes from 'prop-types';
import React from 'react';

import * as styles from '../../templates/solutionListing.module.scss';
import CardListing from '../Blog/CardListing';
import ContentContainer from '../PageSections/ContentContainer';
import PageSection from '../PageSections/PageSection';

const ResourceListingPage = (props) => {
  return (
    <>
      <PageSection slim isTopSection className={styles.head} data-analytics-section={'resource-content-header'}>
        <h1 data-analytics-component={`card-listing-header`} data-analytics-id={props.title}>
          <a href={'/resources/'} data-analytics-component={'back-to-resources'}>
            Resources
          </a>{' '}
          / <span>{props.title}</span>
        </h1>
      </PageSection>
      <ContentContainer data-analytics-section={'card-content-list'}>
        <CardListing useContentType={true} posts={props.posts} />
      </ContentContainer>
    </>
  );
};

ResourceListingPage.propTypes = {
  title: PropTypes.string,
  posts: PropTypes.arrayOf(PropTypes.any),
};

export default ResourceListingPage;
